import { render, staticRenderFns } from "./Docentes.vue?vue&type=template&id=0e22d06e&"
import script from "./Docentes.vue?vue&type=script&lang=js&"
export * from "./Docentes.vue?vue&type=script&lang=js&"
import style0 from "./Docentes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports